import httpClient from '~/http/services/pos';

export const fetchPermissions = () => {
  return httpClient.get<{ permissions: string[] }>(
    '/api/v2/users/me/permissions'
  );
};
